"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWeave = createWeave;
exports.renameWeave = renameWeave;
const path = __importStar(require("path"));
async function createWeave(input, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    const weavePath = path.join(loomRoot, 'loom', input.weaveSlug);
    if (await deps.fs.pathExists(weavePath)) {
        throw new Error(`A weave already exists at loom/${input.weaveSlug}.`);
    }
    await deps.fs.ensureDir(weavePath);
    return { weaveSlug: input.weaveSlug, filePath: weavePath };
}
/** loom/ entries that are not weaves and must never be a rename source/target. */
const RESERVED_WEAVE_IDS = new Set(['.archive', 'refs', 'chats']);
function assertValidWeaveId(id, label) {
    if (!id || id.includes('/') || id.includes('\\') || id.includes('..')) {
        throw new Error(`Invalid ${label} weave id '${id}'.`);
    }
    if (RESERVED_WEAVE_IDS.has(id)) {
        throw new Error(`'${id}' is a reserved loom/ folder, not a weave.`);
    }
}
/**
 * Rename a weave = rename its `loom/{weaveSlug}` folder. A weave is a pure fs container
 * (no manifest, no title), and every cross-reference is by ULID — so the folder move
 * rewrites zero doc content. Thread `depends_on` edges (thread ULIDs) survive intact.
 */
async function renameWeave(input, deps) {
    assertValidWeaveId(input.weaveSlug, 'source');
    assertValidWeaveId(input.newWeaveSlug, 'target');
    if (input.weaveSlug === input.newWeaveSlug) {
        return { from: input.weaveSlug, to: input.newWeaveSlug };
    }
    const loomRoot = deps.getActiveLoomRoot();
    const from = path.join(loomRoot, 'loom', input.weaveSlug);
    const to = path.join(loomRoot, 'loom', input.newWeaveSlug);
    if (!(await deps.fs.pathExists(from)))
        throw new Error(`Weave '${input.weaveSlug}' not found.`);
    if (await deps.fs.pathExists(to))
        throw new Error(`A weave '${input.newWeaveSlug}' already exists.`);
    await deps.fs.move(from, to, { overwrite: false });
    return { from: input.weaveSlug, to: input.newWeaveSlug };
}
